import { QueryObserverOptions } from 'react-query';

import { makeResourceKeys } from 'requests/resources/makeResources/makeResourcesKeys';
import { useEntityMany } from 'requests/resources/makeResources/queries';
import { Params } from 'requests/resources/makeResources/types';

import { useUserSubscripton } from '../subscription/useUserSubscription';
import { User } from '../types';

const keys = makeResourceKeys('users');

const USER_MANY_ENDPOINT_POSTFIX = ''; // => `/users`

export default function useUserMany(params: Params = {}, options?: QueryObserverOptions<User[]>) {
  useUserSubscripton();
  const userQuery = useEntityMany<User[]>(keys.many, USER_MANY_ENDPOINT_POSTFIX, params, options);
  return userQuery;
}
